import { subscription } from 'nike-re-framejs';
import { activeFavoriteMatchCount$ } from '../../favorite/subs';
import { matchesOnTicketsCount$ } from '../tickets/subs';

export const myMatchesCount$ = subscription(
    (favoritesCount, activeCount) => favoritesCount + activeCount,
    activeFavoriteMatchCount$,
    matchesOnTicketsCount$
);
